/**
 * Errors surfaced while resolving sign-in link text for clipboard copy.
 */
export class SignInLinkCopySourceError extends Error {
  readonly code: 'api' | 'empty-link';

  constructor(
    code: 'api' | 'empty-link',
    message: string,
    readonly details?: Record<string, unknown>
  ) {
    super(message);
    this.name = 'SignInLinkCopySourceError';
    this.code = code;
  }
}

export function isSignInLinkCopySourceError(error: unknown): error is SignInLinkCopySourceError {
  return error instanceof SignInLinkCopySourceError;
}
